const steps = [
  {
    num: '01',
    title: 'Otwórz Arkusz',
    desc: 'Kliknij przycisk "Kakobuy Sheet" i przejdź do naszego arkusza na kaspreadsheet.com, gdzie znajdziesz wszystkie kategorie produktów.',
  },
  {
    num: '02',
    title: 'Wybierz Kategorię',
    desc: 'Przeglądaj 14 kategorii – od Shoes po Perfumes – i znajdź interesujące Cię produkty w naszym Kakobuy Spreadsheet.',
  },
  {
    num: '03',
    title: 'Kopiuj Link',
    desc: 'Skopiuj link do wybranego produktu z arkusza i wklej go w panelu agenta zakupowego Kakobuy, aby sprawdzić cenę i dostępność.',
  },
  {
    num: '04',
    title: 'Zamów i Ciesz Się',
    desc: 'Złóż zamówienie przez agenta Kakobuy, wybierz wysyłkę do Polski i ciesz się wysokiej jakości produktami w świetnych cenach.',
  },
];

const HowItWorks = () => {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <p className="text-accent-500 text-sm tracking-widest uppercase mb-3 font-medium">
            Prosty proces
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Jak Działa <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            Korzystanie z naszego arkusza jest banalnie proste. Oto cztery kroki, które dzielą Cię od znalezienia idealnych produktów.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative text-center group">
              <div className="bg-background-100 border border-background-200 group-hover:border-accent-200 rounded-xl p-6 transition-all duration-300 group-hover:-translate-y-1">
                <span className="inline-block text-4xl font-heading font-bold text-accent-300 mb-3">
                  {step.num}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-accent-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap shadow-lg shadow-accent-500/20 hover:-translate-y-0.5"
          >
            <i className="ri-file-list-3-line"></i>
            Rozpocznij z Kakobuy Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;